module.exports = __webpack_public_path__ + "2b54143842e8fdba097edad74b39cad6.svg";